var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.CEMS.value
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": _vm.CEMS.text,
      "bgImage": "/images/sub/product/cems-bg.jpg",
      "image": "/images/sub/product/cems-img.png"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" At KIE Systems, we understand the importance of monitoring emissions and air quality in order to maintain a healthy environment for all. That's why we have developed a comprehensive solution for CEMS (Continuous Emission Monitoring Systems) and AQMS (Air Quality Monitoring Systems) that is both reliable and cost-effective. ")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" Our solution is designed to help organizations of all sizes and industries to monitor and measure emissions and air quality in real-time. We utilize state-of-the-art technology from trusted vendors to ensure that our clients receive the most accurate and reliable data possible. ")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" Our system includes a variety of monitoring equipment, such as analyzers, sampling systems and sensors that can detect and measure a wide range of pollutants and gases. ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" In addition to monitoring and measuring emissions, our solution also includes a powerful data analysis and reporting system that allows our clients to easily access and interpret the data we collect. This means that organizations can quickly identify areas where improvements need to be made and take action to reduce emissions and improve air quality. ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }